import { Connection } from "@domain/connection/models/Connection";
import { ConnectionDTO } from "../dto/MarketplaceDTOs";
import { ConnectorMapper } from "./ConnectorMapper";

export class ConnectionMapper {
    static toModel(dto: ConnectionDTO): Connection {
        return {
            id: dto.id,
            companyId: dto.companyId,
            name: dto.name,
            authorized: dto.authorized ?? true,
            active: dto.active ?? true,
            connector: ConnectorMapper.toModel(dto.connector)
        };
    }

    static toDTO(model: Connection): ConnectionDTO {
        return {
            id: model.id,
            companyId: model.companyId,
            name: model.name,
            authorized: model.authorized,
            active: model.active,
            connector: ConnectorMapper.toDTO(model.connector)
        };
    }
}
